var map = {
	"./1.png": "c1c5",
	"./10.png": "5f7f",
	"./2.png": "81e5",
	"./3.png": "619a",
	"./4.png": "33b2",
	"./5.png": "4660",
	"./6.png": "97ca",
	"./7.png": "8efd",
	"./8.png": "570d",
	"./9.png": "0768",
	"./Ellipse10.png": "3ee6",
	"./Ellipse11.png": "015c",
	"./Ellipse7.png": "b4ae",
	"./Frame.png": "2527",
	"./Group21.png": "c063",
	"./Group27.png": "f91f",
	"./Group3.png": "893a",
	"./Group4.png": "a06e",
	"./Group40.png": "fe41",
	"./Group5.png": "36c9",
	"./Group50.png": "c033",
	"./Group6.png": "cc11",
	"./Maskgroup.png": "0c06",
	"./Rectangle30.png": "ba35",
	"./Rectangle31.png": "c12a",
	"./Vector (8).png": "73c9",
	"./Vector (9).png": "9319",
	"./add.png": "fbc1",
	"./addr-new.png": "0d95",
	"./adviser.png": "69b5",
	"./alreadyServic.png": "dc16",
	"./avatar.png": "4d41",
	"./banner.png": "1936",
	"./bgi1.png": "d96e",
	"./bgi2.png": "6186",
	"./bluepoint.png": "cf2e",
	"./caipin_empty.png": "4b2e",
	"./cardIcon.png": "5366",
	"./cardIcon1.png": "09ac",
	"./classify.png": "ba99",
	"./clock.png": "fa24",
	"./close.png": "d991",
	"./eye.png": "a33f",
	"./eye1.png": "b02c",
	"./eye2.png": "5603",
	"./family.png": "0f82",
	"./fjzl-s.png": "4ce9",
	"./food-1.png": "3ff0",
	"./food1.png": "37a1",
	"./food2.png": "3312",
	"./food3.png": "cb06",
	"./food4.png": "96c9",
	"./food5.png": "067e",
	"./food6.png": "aab0",
	"./friends.png": "10a1",
	"./fwcs-s.png": "4360",
	"./fwxm-s.png": "9741",
	"./ggss-s.png": "82fb",
	"./location.png": "5f53",
	"./location1.png": "8915",
	"./logo.png": "9d64",
	"./manAvatar.png": "b25f",
	"./nav1.png": "1c8b",
	"./nav2.png": "3e50",
	"./nav3.png": "5952",
	"./nav4.png": "1162",
	"./nav5.png": "49e6",
	"./online.png": "edc9",
	"./personInfo.png": "056c",
	"./phone-1.png": "9bbe",
	"./phone-2.png": "a4b6",
	"./phone-new.png": "ac2f",
	"./phone.png": "1e37",
	"./pointer.png": "13d9",
	"./police.png": "80a3",
	"./police_logo.png": "adff",
	"./policyInfo.png": "d017",
	"./qrcode.png": "a76d",
	"./record.png": "9031",
	"./redMark.png": "7d65",
	"./redpoint.png": "a5d3",
	"./self.png": "31a2",
	"./shower.png": "176e",
	"./success.png": "46e6",
	"./tabs_bg.png": "2ebb",
	"./text.png": "1069",
	"./title.png": "35cc",
	"./tx1.png": "ddd5",
	"./tx2.png": "f402",
	"./tx3.png": "1aec",
	"./tx4.png": "6004",
	"./tx5.png": "8996",
	"./wx.png": "6215",
	"./yellowpoint.png": "927b",
	"./yljg-s.png": "7d17",
	"./youngman.png": "2f1a",
	"./youngwoman.png": "0058",
	"./yth.png": "06c4",
	"./zcd-s.png": "1333",
	"./养老院.png": "d3ca",
	"./分割线.png": "4881",
	"./助餐点.png": "8413",
	"./外部链接.png": "ce8f",
	"./大荤.png": "bfd5",
	"./家门口养老服务站.png": "f6e7",
	"./小荤.png": "3586",
	"./社区为老服务站.png": "96c6",
	"./素菜.png": "e1b2",
	"./综合为老服务中心.png": "8462",
	"./老年日托所.png": "65e5",
	"./老年活动室.png": "b6501",
	"./适老化智慧养老体验中心.png": "6770",
	"./长者照护之家.png": "601f",
	"./长者运动健康之家.png": "65d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";